import { calendarDaysIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const DateRange = createIcon({
  displayName: 'DateRange',
  paths: [
    'M768 810.667h-512v-426.667h512v426.667zM768 213.333h-85.333v-42.667c0-23.595-19.115-42.667-42.667-42.667s-42.667 19.072-42.667 42.667v42.667h-170.667v-42.667c0-23.595-19.115-42.667-42.667-42.667s-42.667 19.072-42.667 42.667v42.667h-85.333c-47.104 0-85.333 38.229-85.333 85.333v512c0 47.104 38.229 85.333 85.333 85.333h512c47.104 0 85.333-38.229 85.333-85.333v-512c0-47.104-38.229-85.333-85.333-85.333zM384 725.333c-23.552 0-42.667-19.072-42.667-42.667s19.115-42.667 42.667-42.667h85.333c23.552 0 42.667 19.072 42.667 42.667s-19.115 42.667-42.667 42.667h-85.333zM384 554.667h256c23.552 0 42.667-19.072 42.667-42.667s-19.115-42.667-42.667-42.667h-256c-23.552 0-42.667 19.072-42.667 42.667s19.115 42.667 42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(calendarDaysIcon)
})
